export default "__VITE_ASSET__BrkCPqlY__"